import { combineReducers } from 'redux';
import mapping from './mapping.reducer';

const reducer = combineReducers({
	mapping
});

export default reducer;